'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './business-profile.routes';

export class BusinessProfileComponent {
  constructor($stateParams, BusinessService, Auth, dialogs, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.dialogs = dialogs;

    this.profileConfig = Config.getModuleConfig(Config.Modules.Profile);

    this.phoneTypes = this.profileConfig.getPhoneTypes();
    this.socialMediaTypes = this.profileConfig.getSocialMediaTypes();
    this.mailTypes = this.profileConfig.getMailTypes();
    this.addressTypes = this.profileConfig.getAddressTypes();

    this.vendorCategories = Config.getModuleConfig(Config.Modules.Directories).getVendorCategories();

    this.isAdmin = Auth.isAdminSync();

    this.BusinessService = BusinessService;

    this.businessId = $stateParams.id;
    this.user = Auth.getCurrentUserSync();

    if (this.businessId) {

      BusinessService.get({id: this.businessId}, business => {
        this.business = business;

        // foreign profile
        this.isForeignProfile = this.user._id !== business.meta.creationUser;

        if (this.isAdmin && this.vendor) {
          this.isForeignProfile = false;
        }

        if (this.vendor && this.show) {
          this.isForeignProfile = true;
        }
      });

    } else {

      let newBusiness = {
        name: this.user.firstName + " " + this.user.lastName + "'s Business",
        meta: {
          creationUser: this.user._id
        }
      };

      if (this.vendor) {
        newBusiness.name = "New Vendor";
        newBusiness.isVendor = true;
      }

      this.business = BusinessService.save(newBusiness);
    }
  }

  checkValidEmail(mail) {
    var reBasicEmailValidation = /\S+@\S+\.\S+/;
    if (!reBasicEmailValidation.test(mail)) {
      return "Please enter a valid email address";
    }
  }

  formatDialogElementInfo(elmInfo) {
    return "<br/><br/><b>"+elmInfo+"</b>";
  }

  addPhone() {
    this.business.phone.push({
      type: this.profileConfig.getDefaultPhoneTypeWork(),
      number: '',
      private: false
    });
  };

  removePhone(idx) {
    var phone = this.business.phone[idx];
    var phoneString = phone.type + " " + phone.number;

    var dlg = this.dialogs.confirm(
      "Remove phone number?",
      "Do you really want to delete this phone number?" + this.formatDialogElementInfo(phoneString));
    dlg.result.then(() => {
      this.business.phone.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addMail() {
    this.business.email.push({
      type: this.profileConfig.getDefaultMailTypeWork(),
      address: '',
      private: false
    });
  };

  removeMail(idx) {
    var mail = this.business.email[idx];
    var mailString = mail.type + " " + mail.address;

    var dlg = this.dialogs.confirm(
      "Remove email?",
      "Do you really want to delete this email address?"+ this.formatDialogElementInfo(mailString));
    dlg.result.then(() => {
      this.business.email.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addUrl() {
    this.business.url.push({address: "http://"});
  };

  removeUrl(idx) {
    var url = this.business.url[idx];
    var urlString = url.address;

    var dlg = this.dialogs.confirm(
      "Remove website?",
      "Do you really want to delete this website?"+ this.formatDialogElementInfo(urlString));
    dlg.result.then(() => {
      this.business.url.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addSocialMedia() {
    this.business.socialMedia.push({
      type: this.profileConfig.getDefaultSocialMediaTypeWork(),
      link: ''
    });
  };

  removeSocialMedia(idx) {
    var social = this.business.socialMedia[idx];
    var socialString = social.type + " " + social.link;

    var dlg = this.dialogs.confirm(
      "Remove social link?",
      "Do you really want to delete this social media entry?" + this.formatDialogElementInfo(socialString));
    dlg.result.then(() => {
      this.business.socialMedia.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addAddress() {
    this.business.address.push({
      type: this.profileConfig.getDefaultAddressTypeWork()
    });
  };

  removeAddress(idx) {
    var address = this.business.address[idx];
    var addressString = (address.street || '') + "<br/>"
      + (address.street2 || '' ) + "<br/>"
      + (address.city || '') + " " + (address.state || '')  + " " + (address.zip || '') + "<br/>"
      + (address.country || '');

    var dlg = this.dialogs.confirm(
      "Remove address?",
      "Do you really want to delete this address?" + this.formatDialogElementInfo(addressString));
    dlg.result.then(() => {
      this.business.address.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  saveChanges() {
    this.BusinessService.update({id: this.business._id}, this.business);
  }
}

export default angular.module('conduuApp.businessProfile', [uiRouter])
  .config(routes)
  .component('businessProfile', {
    template: require('./business-profile.html'),
    controller: BusinessProfileComponent,
    controllerAs: 'profileCtrl',
    bindings: {
      vendor: '<',
      show: '<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/business/profile/business-profile.component.js